import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export function ErrorPage() {
  return (
    <Box sx={{ textAlign: 'center', p: 8 }}>
      <Typography variant="h2" gutterBottom>
        404
      </Typography>
      <Typography color="text.secondary" gutterBottom>
        This is not the web page you are looking for.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
        Back home
      </Button>
    </Box>
  );
}
